import React from "react";
import SlidingIconButton from "./SlidingIconButton";

interface MakeConnectionButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const MakeConnectionButton: React.FC<MakeConnectionButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <SlidingIconButton
      color="text-white"
      text="Maak connectie"
      iconClass="d-network-policy"
      className="w-[9.5rem] hover:border-seafoamGreen"
      onClick={onClick}
      openByDefault={true}
      reverse={false}
      disabled={disabled}
    />
  );
};

export default MakeConnectionButton;
